<h1 mat-dialog-title *ngIf="!data?.url">{{'admin.channel.addNew' | translate}}</h1>
<h1 mat-dialog-title *ngIf="data?.url">{{'admin.channel.edit' | translate}}</h1>

<div>
    <form [formGroup]="form">
        <mat-form-field appearance="standard" color="standart" style="margin-bottom: -10px;">
            <mat-label>{{"admin.channel.url" | translate }}<span class="span-label-required"></span></mat-label>
            <input matInput formControlName="url" pattern="http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?[\w\?‌​=]*)?">
        </mat-form-field>
        <span style="color: red;" *ngIf="(form.get('url').errors?.required && (form.get('url').touched || (form.get('url').dirty)))">
            {{"common.validation.youtube.linkRequired" | translate}}
        </span>
        <span style="color: red;" *ngIf="(form.get('url').errors?.pattern && (form.get('url').touched || (form.get('url').dirty)))">
            {{"admin.channel.invalidLink" | translate}}
        </span>

        <mat-form-field appearance="standard" color="standart" style="margin-bottom: -10px; margin-top: 25px;">
            <mat-label>{{"admin.channel.description" | translate }}<span class="span-label-required"></span></mat-label>
            <textarea matInput formControlName="description" rows="3"></textarea>
        </mat-form-field>
        <span style="color: red;" [style.visibility]="(form.get('description').errors && (form.get('description').touched || (form.get('description').dirty))) ? 'visible' : 'hidden'">
            {{"common.validation.youtube.descriptionRequired" | translate}}
        </span>
    </form>

    <div class="d-flex" style="margin-top: 20px;">
        <button mat-flat-button color="primary" (click)="save()" class="action-button">{{'common.buttons.save' | translate}}</button>
        <button mat-flat-button color="primary" (click)="discard()" class="action-button">{{'common.buttons.cancel' | translate}}</button>
    </div>
</div>
